export default __webpack_public_path__ + "static/media/nationale-nederlanden.291cf09c.svg";